module.exports = __webpack_public_path__ + "components/resort-guide/item/static/icon-cablecar--black-6fb42968b10f0397277f4b028603d7b7.svg";